import React, { Component } from 'react'

class Button extends Component {
    render() {
        const { action, type, text, ...other } = this.props

        return (
            <button className="btn" onClick={e => action(e)} {...other}>{text}</button>
        )
    }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/modal/Button.js